import React, { useRef } from 'react';
import {
  ListBase,
  ListToolbar,
  Pagination,
  useRefresh,
  Title,
  Datagrid,
} from 'react-admin';

import { Card, makeStyles } from '@material-ui/core';
import VisibilityIcon from '@material-ui/icons/Visibility';

import {} from '../../utils/dadosTelas';
import ActionsList from '../../Components/ReactAdmin/ActionsList';
import ActionsField from '../../Components/ReactAdmin/Fields/ActionsField';
import Textofield from '../../Components/ReactAdmin/Fields/TextoField';
//import ActionsField from './ActionsField';
import { ProtegerPagina } from '../../layout/VerificaPermissaoPage';
import DialogoSugestaoPreCompra from './DialogoSugestaoPreCompra';
import PedidoMinimoField from './Fields/PedidoMinimoField';
import ValorField from './Fields/ValorField';
import Filter from './Filter';

const useStyles = makeStyles((theme) => ({
  dataHeader: {
    flex: 1,
    backgroundColor: theme.palette.secondary.main,
    padding: '10px',
    color: 'white',
    fontWeight: 500,
    lineHeight: '1.5rem',
    fontSize: '0.875rem',
    borderBottom: '1px solid rgba(224, 224, 224, 1)',
    borderSpacing: 0,
    borderCollapse: 'collapse',
  },
  dataCell: {
    flex: 1,
    padding: '10px',
    fontWeight: 500,
    lineHeight: '1.5rem',
    fontSize: '0.875rem',
    borderSpacing: 0,
    borderCollapse: 'collapse',
  },
}));
//
const MyList = ({ ...props }) => {
  const refDialogoSugestaoPreCompra = useRef(null);
  const refresh = useRefresh();
  const classes = useStyles();

  function handleShow({ id }) {
    if (refDialogoSugestaoPreCompra.current)
      refDialogoSugestaoPreCompra.current.handleOpen(id);
  }

  const handleClose = () => {
    refresh();
  };

  return (
    <>
      <Title title="Sugestão de Pré Compras" />
      <ListToolbar
        filters={props.filters}
        actions={<ActionsList {...props} />}
        {...props}
      />
      <Card style={{ borderRadius: '20px' }} {...props}>
        <Datagrid {...props}>
          <Textofield
            source="fornecedor.razao_social"
            label="Fornecedor"
            sortable={false}
            headerClassName={classes.dataHeader}
            cellClassName={classes.dataCell}
          />
          <Textofield
            source="responsavel.nome"
            label="Responsável"
            sortable={false}
            headerClassName={classes.dataHeader}
            cellClassName={classes.dataCell}
          />
          <ValorField
            source="valor"
            label="R$ Pedido"
            //sortable={false}
            headerClassName={classes.dataHeader}
            cellClassName={classes.dataCell}
          />
          <PedidoMinimoField
            source="is_pedido_minimo"
            label="Pedido Mínimo?"
            //sortable={false}
            headerClassName={classes.dataHeader}
            cellClassName={classes.dataCell}
          />
          <ActionsField
            source="valor"
            textAlign="right"
            label="Ações"
            sortable={false}
            headerClassName={classes.dataHeader}
            cellClassName={classes.dataCell}
            //handleShow={handleShow}
            actions={[
              {
                title: 'Detalhes',
                icon: <VisibilityIcon />,
                onClick: (record) => handleShow(record),
              },
            ]}
          />
        </Datagrid>
        <TransacoesPagination />
      </Card>
      <DialogoSugestaoPreCompra
        ref={refDialogoSugestaoPreCompra}
        handleClose={handleClose}
      />
    </>
  );
};

const ContainerMyList = ({ children, ...props }) => (
  <>
    <ListBase {...props}>
      <MyList {...props} />
    </ListBase>
  </>
);

const TransacoesPagination = (props) => (
  <Pagination rowsPerPageOptions={[10, 25, 50, 100]} {...props} />
);

const List2 = (props) => (
  <ProtegerPagina permissao="publico">
    <ContainerMyList
      {...props}
      bulkActionButtons={false}
      pagination={<TransacoesPagination />}
      perPage={50}
      filters={<Filter />}
      //title="Sugestão de Pré Compras"
      component="div"
    />
  </ProtegerPagina>
);

export default List2;
